import * as _ from 'lodash';
import { ChangeEvent, Component } from 'react';
import { IListItem, IManualInvoiceLineItemTax } from '@nkr/models/index';
import { Button, FormGroup } from 'react-bootstrap';

type LineItemProps = {
    centerId: number,
    lineItems: IManualInvoiceLineItemTax[],
    lineItemTypeList: IListItem[],
    onAddLineItem: (lineItem: IManualInvoiceLineItemTax) => void
}

interface IState {
    id: number,
    lineItemType: number,
    taxPercent: number,
    isDirty: boolean,
    isValid: boolean,
    validation: {
        lineItemTypeValid: boolean,
        taxPercentValid: boolean,
        alreadyExistsValid: boolean
    }
}

class ManualTaxLineItemAddFormRow extends Component<LineItemProps, IState> {
    readonly state: IState = {
        id: 0,
        lineItemType: -1,
        taxPercent: 0,
        isDirty: false,
        isValid: true,
        validation: {
            lineItemTypeValid: false,
            taxPercentValid: false,
            alreadyExistsValid: false
        }
    }

    handleFieldChange = (e: ChangeEvent<HTMLInputElement & HTMLSelectElement>) => {
        let { name, value } = e.currentTarget;

        if (name == 'lineItemType') {
            this.setState({
                lineItemType: parseInt(value)
            });
        } else if (name == 'taxPercent') {
            this.setState({
                taxPercent: parseFloat(value)
            });
        }
    }

    handleAddLineItem = () => {
        let validation = this.validate();

        this.setState({
            validation,
            isDirty: true
        }, () => {
            let { id, taxPercent, lineItemType } = this.state;
            let { taxPercentValid, lineItemTypeValid, alreadyExistsValid } = validation;
            let valid = taxPercentValid && lineItemTypeValid && alreadyExistsValid;

            if (valid) {
                let lineItem: IManualInvoiceLineItemTax = {
                    id,
                    taxPercent,
                    lineItemType,
                    lineItemTypeDesc: ''
                };

                this.props.onAddLineItem(lineItem);

                this.setState({
                    lineItemType: -1,
                    taxPercent: 0
                });
            }
        })
    }

    validate = () => {
        let { lineItemType, taxPercent } = this.state;
        let alreadyExists = this.props.lineItems.find(x => x.lineItemType == lineItemType);

        return {
            lineItemTypeValid: lineItemType > -1,
            taxPercentValid: taxPercent != 0,
            alreadyExistsValid: !alreadyExists
        };
    }

    render = () => {
        let { lineItemType } = this.state;
        let alreadyExists = this.props.lineItems.find(x => x.lineItemType == lineItemType);

        return (
            <tfoot style={{ overflow: 'visible' }}>
                <tr>
                    <td>
                        <FormGroup validationState={(this.state.isDirty && (!this.state.validation.lineItemTypeValid)) || alreadyExists ? 'error' : null}>
                            <select
                                name='lineItemType'
                                className='form-control'
                                value={this.state.lineItemType}
                                onChange={this.handleFieldChange}
                            >
                                <option value={-1}>Select</option>
                                {this.props.lineItemTypeList.map((item, index) =>
                                    <option key={'type-' + index} value={item.id}>{item.description}</option>
                                )}
                            </select>

                            {alreadyExists && (
                                <tr style={{ marginBottom: 10, color: '#d9534f', fontWeight: 'bold' }}>
                                    <td >
                                        Line item already exists for your center
                                    </td>
                                </tr>
                            )}
                        </FormGroup>
                    </td>
                    <td>
                        <FormGroup validationState={this.state.isDirty && !this.state.validation.taxPercentValid ? 'error' : null}>
                            <input name='taxPercent' className='form-control' type='number' value={this.state.taxPercent} onChange={this.handleFieldChange} />
                        </FormGroup>
                    </td>
                    <td><Button bsStyle='primary' bsSize='sm' block onClick={this.handleAddLineItem}>Add</Button></td>
                </tr>
            </tfoot>
        );
    }
}

export default ManualTaxLineItemAddFormRow;